import { NextImage } from '@zurich-framework/nextapp/components';
import { useTranslation } from '@zurich/common/hooks';
import { Stack, Typography } from '@zurich/ui/atoms';
import { Notice } from '@zurich/ui/legacy/components';
import { StepLayout } from '~/components/Steps/StepLayout';
import type { StepNames } from '~/lib/types';

export interface PhotoLayoutProps {
  subtitle: string;
  bodyBold?: string;
  body1?: string;
  illustration: string;
  cameraButtonText: string;
  stepName: StepNames;
  documentDamage: boolean;
  tipTranslationKey?: string;
}
export function PhotoLayout({
  subtitle,
  bodyBold,
  body1,
  illustration,
  cameraButtonText,
  stepName,
  tipTranslationKey,
  documentDamage = false,
}: PhotoLayoutProps) {
  const { t } = useTranslation();
  return (
    <StepLayout
      stepName={stepName}
      cameraButtonText={t(cameraButtonText)}
      documentDamage={documentDamage}
    >
      <Stack flexDirection="column" gap={3}>
        {subtitle && (
          <Typography variant="h5" color="darkBlue">
            {t(subtitle)}
          </Typography>
        )}
        <Stack flexDirection="column" gap={1}>
          {bodyBold && (
            <Typography variant="body2 semibold" color="darkBlue">
              {t('vsga:damagePhoto.bodyBold')}
            </Typography>
          )}
          {body1 && (
            <Typography variant="body2 regular" color="darkBlue">
              {t(body1)}
            </Typography>
          )}
        </Stack>
        {tipTranslationKey && (
          <Notice type="neutral">{t(tipTranslationKey)}</Notice>
        )}
      </Stack>
      {illustration && (
        <Stack flexDirection="row" justifyContent="center">
          <NextImage
            width={300}
            height={85}
            src={illustration}
            alt={t(subtitle)}
          />
        </Stack>
      )}
    </StepLayout>
  );
}
